<template>
  <el-dialog
    v-model="dialogVisible"
    width="660"
    :style="{ marginTop: '10px' }"
    center
    :close-on-click-modal="false"
    destroy-on-close
    @close="closeDialog"
  >
    <template #header>
      <div class="my-header">
        <p class="title">{{ getTitle }}</p>
      </div>
    </template>
    <div class="content">
      <el-carousel
        v-if="showType === 'list'"
        indicator-position="none"
        :interval="5000"
        :height="carouselHeight"
        @change="changeCarousel"
      >
        <el-carousel-item v-for="item in msgData" :key="item.id" class="carousel-one">
          <p class="title">{{ item.title }}</p>
          <div v-html="addMaxWidthToImages(item.content)" class="editor-content-view" ref="editorContentView"></div>
        </el-carousel-item>
      </el-carousel>
      <div v-else>
        <p class="title">{{ msgData.title }}</p>
        <div v-html="addMaxWidthToImages(msgData.content)" class="editor-content-view"></div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button v-if="showType === 'list'" type="text" @click="noRemindMsg">不再接收此通知</el-button>
        <el-button type="primary" @click="confirmMsg">知道了</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import dayjs from 'dayjs';
import { ref, computed } from 'vue';
import { rootStore } from '@/store/rootStore';
import { ElMessage } from 'element-plus';
import { debounce } from 'lodash';
import request from '@/lib/request';
import apiPath from '@/lib/apiPath';
import { BACKEND_ID } from '@/lib/utils';
import { reportLogs } from '@/lib/bigDataTrack';
const emits = defineEmits(['updateSuccess']);

const store = rootStore();

const titleMap = {
  1: '系统公告',
  2: '站内消息',
  3: '其他消息',
};
const getTitle = computed(() => {
  return titleMap[msgData.value?.type ?? 1];
});

const dialogVisible = ref(false);
const msgData = ref({});
const showType = ref('one');
const showId = ref('');
const initModal = async (row, type = 'one') => {
  showId.value = type === 'list' ? row[0].id : row.id;
  showType.value = type;
  msgData.value = row;
  dialogVisible.value = true;
  updateCarouselHeight();
};
const changeCarousel = (newIndex) => {
  showId.value = msgData.value[newIndex].id;
  updateCarouselHeight(newIndex);
};
const closeDialog = () => {
  reportLogs('$Click', {
    $module: '按钮-关闭公告',
  });
};
const confirmMsg = () => {
  if (showType.value === 'list') {
    request.get(`${apiPath.notification.message}/${showId.value}`).then((res) => {
      const targetDate = dayjs(res.created_at);
      const now = dayjs();
      const diffInSeconds = now.diff(targetDate, 'second'); // 计算差异的单位为秒
      reportLogs('$Click', {
        $module: '按钮-已读公告',
        $duration: diffInSeconds,
      });
      const index = msgData.value.findIndex((item) => item.id === showId.value);
      // 将showId置为下一条信息，再移除原信息
      showId.value = msgData.value[index + 1]?.id || 0;
      msgData.value.splice(index, 1);
      getUnreadCount(); // 重新获取未读信息数
      msgData.value.length === 0 && (dialogVisible.value = false);
      updateCarouselHeight();
    });
  } else {
    dialogVisible.value = false;
  }
};
const getUnreadCount = () => {
  request
    .get(apiPath.notification.getUnreadCount, {
      backend_id: BACKEND_ID,
    })
    .then((res) => {
      store.setUnreadList(res);
    });
};
const getDialogVisible = () => {
  return dialogVisible.value;
};
const addMaxWidthToImages = (html) => {
  return html.replace(/<img(.*?)>/g, (match, attr) => {
    if (/style=/.test(attr)) {
      return `<img${attr.replace(/style="([^"]*)"/, 'style="$1; max-width: 100%;"')}>`;
    }
    return `<img${attr} style="max-width: 100%;">`;
  });
};
const noRemindMsg = debounce(() => {
  if (showType.value === 'list') {
    request.post(`${apiPath.notification.message}/${showId.value}/no_reminder`).then(() => {
      ElMessage.success('设置成功');
      confirmMsg();
      reportLogs('$Click', {
        $module: `用户拒收消息：${showId.value}`,
      });
    });
  }
}, 500);

const carouselHeight = ref('auto');
const editorContentView = ref(null);
const updateCarouselHeight = (index = 0) => {
  setTimeout(() => {
    const contentView = editorContentView.value;
    if (contentView) {
      // 获取元素高度并更新 carousel 的高度
      const height = contentView[index].offsetHeight + 42;
      carouselHeight.value = `${height < 600 ? height : 600}px`;
    }
  }, 500);
};

defineExpose({ initModal, getDialogVisible });
</script>

<style lang="less" scoped>
.my-header {
  .title {
    font-size: 16px;
    color: #b2b2b2;
    margin-bottom: 0;
  }
}
.content {
  margin-top: -22px;
  .title {
    text-align: center;
    color: #090909;
    font-size: 18px;
    font-weight: bold;
  }
}
.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}
.carousel-one {
  max-height: 600px;
  overflow-x: auto; /* 允许横向滚动 */
  overflow-y: auto; /* 允许纵向滚动 */
}
</style>
